// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.table-responsive table label[for=team-member-items] {
  margin-block: 5px 10px;
}
.table-responsive table .team_list_pagination {
  vertical-align: middle;
}

.teams-lists tr .team-actions {
  position: relative;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}
.teams-lists tr .team-actions .btn-xs {
  position: static !important;
  display: none;
  vertical-align: middle;
}
.teams-lists tr .team-actions .btn-xs:nth-child(2n) {
  left: auto !important;
}
.teams-lists tr .team-actions .btn-xs.btn-info {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0 3px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border-color: rgba(0, 173, 208, 0.15);
}
.teams-lists tr .team-actions .btn-xs.btn-info:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.teams-lists tr .team-actions .btn-xs.btn-danger {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0 3px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  background: rgba(245, 67, 89, 0.08);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.15);
}
.teams-lists tr .team-actions .btn-xs.btn-danger:hover {
  background: rgb(245, 67, 89);
  color: #fff;
}
.teams-lists tr .team-actions .btn-xs.btn-primary {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0 3px;
  border-radius: 6px;
  font-size: 13px;
  position: static !important;
  background: rgba(105, 190, 40, 0.08);
  color: rgb(105, 190, 40);
  border-color: rgba(105, 190, 40, 0.15);
}
.teams-lists tr .team-actions .btn-xs.btn-primary:hover {
  background: rgb(105, 190, 40);
  color: #fff;
}
.teams-lists tr .team-actions .btn-xs.btn-warning {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0 3px;
  border-radius: 6px;
  font-size: 13px;
  position: static !important;
  background: rgba(255, 121, 0, 0.08);
  color: rgb(255, 121, 0);
  border-color: rgba(255, 121, 0, 0.15);
}
.teams-lists tr .team-actions .btn-xs.btn-warning:hover {
  background: rgb(255, 121, 0);
  color: #fff;
}
.teams-lists tr:hover .team-actions .btn-xs.btn-danger {
  opacity: 1;
  pointer-events: auto;
}

.sample {
  background: #676a6c;
  color: #fff;
  margin-left: 10px;
  padding: 3px 10px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 12px;
}

.search-res {
  background-color: #f5f5f6;
  margin: 0;
  padding-block: 10px;
  padding-inline: 10px;
  border-radius: 4px;
  border-bottom: 1px solid #ddd;
}

.table-sortable > thead > tr > th,
.table-sortable > tbody > tr > td {
  padding: 7px 10px;
  vertical-align: middle;
}

.org-table {
  table-layout: fixed;
  width: 100%;
}
.org-table col.oc-org {
  width: 30%;
}
.org-table col.oc-members {
  width: 8%;
}
.org-table col.oc-pricing {
  width: 7%;
}
.org-table col.oc-buyer {
  width: 15%;
}
.org-table col.oc-profiles {
  width: 8%;
}
.org-table col.oc-indiv {
  width: 9%;
}
.org-table col.oc-group {
  width: 10%;
}
.org-table col.oc-act {
  width: 13%;
}

.org-cell__name {
  white-space: normal;
  word-break: break-word;
}

.org-cell__name a {
  font-weight: 600;
}

.org-buyer {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invn-col-num {
  text-align: center;
  white-space: nowrap;
}

.invn-keynum {
  color: #138a72;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.15s ease;
}
.invn-keynum:hover {
  color: rgb(0, 173, 208);
}

.orgs-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e7eaec;
  flex-wrap: wrap;
}
.orgs-pager__left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.orgs-pager__info {
  font-size: 12px;
  color: #ccc;
}
.orgs-pager__ctrls {
  display: flex;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.orgs-pager__ctrls li {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.orgs-pager__ctrls li:hover:not(.active) {
  background: #f1f1f2;
  border-color: #ccc;
}
.orgs-pager__ctrls li.active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}

.orgs-perpage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #ccc;
}
.orgs-perpage select {
  padding: 4px 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  color: #676a6c;
  cursor: pointer;
  outline: none;
  background: #fff;
}

.invn-acts {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.invn-act {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  background: transparent;
  color: #9aa0a6;
  border: 1px solid #e7eaec;
  transition: all 0.2s ease;
}
.invn-act.is-empty {
  opacity: 0.28;
  cursor: default;
  pointer-events: none;
  border-style: dashed;
}
.invn-act--addmem:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
  transform: scale(1.08);
}
.invn-act--graph:hover {
  background: #1c84c6;
  color: #fff;
  border-color: #1c84c6;
  transform: scale(1.08);
}
.invn-act--edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  transform: scale(1.08);
}
.invn-act--del:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(245, 67, 89, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/orgs/roster-table-view/roster-table-view.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA3YI;EACE,sBAAA;AA8YN;AA3YI;EACE,sBAAA;AA6YN;;AA5XI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AA+XN;AA7XM;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;AA+XR;AA5XM;EACE,qBAAA;AA8XR;AA1XM;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,mCAAA;EACA,uBDjCQ;ECkCR,qCAAA;AA4XR;AA1XQ;EACE,4BDrCM;ECsCN,WAAA;AA4XV;AAvXM;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,8BAAA;EACA,mCAAA;EACA,uBDvDU;ECwDV,qCAAA;AAyXR;AAvXQ;EACE,4BD3DQ;EC4DR,WAAA;AAyXV;AApXM;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,oCAAA;EACA,wBD9EQ;EC+ER,sCAAA;AAsXR;AApXQ;EACE,6BDlFM;ECmFN,WAAA;AAsXV;AAjXM;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,uBDrGO;ECsGP,qCAAA;AAmXR;AAjXQ;EACE,4BDzGK;EC0GL,WAAA;AAmXV;AA5WE;EACE,UAAA;EACA,oBAAA;AA8WJ;;AAtWA;EACE,mBD/GmB;ECgHnB,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAyWF;;AAtWA;EACE,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;AAyWF;;AApWE;;EACoB,iBAAA;EAAmB,sBAAA;AAyWzC;;AArWA;EACE,mBAAA;EACA,WAAA;AAwWF;AAjWE;EAAkB,UAAA;AAoWpB;AAnWE;EAAkB,SAAA;AAsWpB;AArWE;EAAkB,SAAA;AAwWpB;AAvWE;EAAkB,UAAA;AA0WpB;AAzWE;EAAkB,SAAA;AA4WpB;AA3WE;EAAkB,SAAA;AA8WpB;AA7WE;EAAkB,UAAA;AAgXpB;AA/WE;EAAkB,UAAA;AAkXpB;;AA7WA;EAAkB,mBAAA;EAAqB,sBAAA;AAkXvC;;AAjXA;EAAoB,gBAAA;AAqXpB;;AAnXA;EAAa,gBAAA;EAAkB,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA0X1E;;AAzXA;EAAgB,kBAAA;EAAoB,mBAAA;AA8XpC;;AA1XA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;AA6XF;AA5XE;EAAU,uBDxLI;ACujBhB;;AA3XA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AA8XF;AA5XE;EAAU,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AAkY3D;AAjYE;EAAU,eAAA;EAAiB,WDjLT;ACsjBpB;AAlYE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAoYJ;AAlYI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cD5Me;EC6Mf,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAoYN;AAlYM;EAAuB,mBD1MP;EC0MyC,kBD3M3C;ACilBpB;AArYM;EAAW,mBD9MI;EC8M6B,WAAA;EAAa,qBD9M1C;ACwlBrB;;AAtYA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,SAAA;EACrD,eAAA;EAAiB,gBAAA;EAAkB,WDlNjB;ACgmBpB;AA7YE;EACE,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EACnD,eAAA;EAAiB,cD5NA;EC4N4B,eAAA;EAAiB,aAAA;EAAe,gBAAA;AAqZjF;;AA/YA;EAAa,aAAA;EAAe,mBAAA;EAAqB,2BAAA;EAA6B,QAAA;AAsZ9E;;AArZA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EAAc,cAAA;EAC/F,kBAAA;EAAoB,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,qBAAA;EACtE,uBAAA;EAAyB,cAAA;EAAgB,yBAAA;EACzC,yBAAA;AAmaF;AA/ZE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;AAiaJ;AA9ZE;EAAkB,6BD9PJ;EC8PgC,WAAA;EAAa,+BD9P7C;EC8P2E,sBAAA;AAoa3F;AAnaE;EAAkB,mBAAA;EAAqB,WAAA;EAAa,qBAAA;EAAuB,sBAAA;AAya7E;AAxaE;EAAkB,4BDlQJ;ECkQgC,WAAA;EAAa,8BDlQ7C;ECkQ2E,sBAAA;AA8a3F;AA7aE;EACE,4BDjQc;ECiQgB,WAAA;EAAa,8BDjQ7B;ECiQ6D,sBAAA;EAC3E,4CAAA;AAkbJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n.table-responsive {\n  table {\n    label[for=\"team-member-items\"] {\n      margin-block: 5px 10px;\n    }\n\n    .team_list_pagination {\n      vertical-align: middle;\n    }\n  }\n}\n\n// ─────────────────────────────────────────\n// Action buttons — no overlap, delete on hover\n// ─────────────────────────────────────────\n\n.teams-lists {\n\n  tr {\n    // No min-width: it forced the column past its <colgroup> share and overflowed the table,\n    // which is what put a scrollbar on .table-responsive (overflow-x: auto).\n    // Left-aligned so the icons line up down the column — centring made rows with a different\n    // number of actions (the graph icon only shows when an org has members) sit off from\n    // each other.\n    .team-actions {\n      position: relative;\n      white-space: nowrap;\n      text-align: left;\n      vertical-align: middle;\n\n      .btn-xs {\n        position: static !important;\n        display: none;\n        vertical-align: middle;\n      }\n\n      .btn-xs:nth-child(2n) {\n        left: auto !important;\n      }\n\n      // Edit — always visible on row hover\n      .btn-xs.btn-info {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 6px;\n        font-size: 13px;\n        cursor: pointer;\n        background: rgba($clarify-color, 0.08);\n        color: $clarify-color;\n        border-color: rgba($clarify-color, 0.15);\n\n        &:hover {\n          background: $clarify-color;\n          color: #fff;\n        }\n      }\n\n      // Delete — hidden by default, shown on row hover\n      .btn-xs.btn-danger {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 6px;\n        font-size: 13px;\n        cursor: pointer;\n        opacity: 0;\n        pointer-events: none;\n        transition: opacity 0.15s ease;\n        background: rgba($implement-color, 0.08);\n        color: $implement-color;\n        border-color: rgba($implement-color, 0.15);\n\n        &:hover {\n          background: $implement-color;\n          color: #fff;\n        }\n      }\n\n      // Save (edit mode)\n      .btn-xs.btn-primary {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 6px;\n        font-size: 13px;\n        position: static !important;\n        background: rgba($develop-color, 0.08);\n        color: $develop-color;\n        border-color: rgba($develop-color, 0.15);\n\n        &:hover {\n          background: $develop-color;\n          color: #fff;\n        }\n      }\n\n      // Cancel (edit mode)\n      .btn-xs.btn-warning {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        width: 30px;\n        height: 30px;\n        padding: 0;\n        margin: 0 3px;\n        border-radius: 6px;\n        font-size: 13px;\n        position: static !important;\n        background: rgba($ideate-color, 0.08);\n        color: $ideate-color;\n        border-color: rgba($ideate-color, 0.15);\n\n        &:hover {\n          background: $ideate-color;\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  // Show delete on row hover\n  tr:hover .team-actions .btn-xs.btn-danger {\n    opacity: 1;\n    pointer-events: auto;\n  }\n}\n\n// ─────────────────────────────────────────\n// Sample badge\n// ─────────────────────────────────────────\n\n.sample {\n  background: $body-content-color;\n  color: #fff;\n  margin-left: 10px;\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.search-res {\n  background-color: #f5f5f6;\n  margin: 0;\n  padding-block: 10px;\n  padding-inline: 10px;\n  border-radius: 4px;\n  border-bottom: 1px solid #ddd;\n}\n\n// Compact cells; let text columns wrap so the table fits (no forced-wide nowrap = no scrollbar)\n.table-sortable {\n  > thead > tr > th,\n  > tbody > tr > td { padding: 7px 10px; vertical-align: middle; }\n}\n\n// Fixed layout = the table is exactly 100% of its container, so it can't overflow horizontally.\n.org-table {\n  table-layout: fixed;\n  width: 100%;\n  // 8 columns summing to 100%, each sized to what it actually needs at the real table width\n  // (~1215px: a 1563px window less the 245px sidebar and the page padding). Headers are\n  // nowrap and the layout is fixed, so a column narrower than its label spills — and the\n  // spill lands in .table-responsive's scroll width as a horizontal scrollbar. Measured\n  // needs: Group+ keys 113px, Indiv keys 98px, Members/Profiles 96px, Buyer 181px,\n  // Actions 152px (4 × 30px icons + 3 × 4px gaps + 20px padding).\n  col.oc-org      { width: 30%; }  // takes the slack; the name wraps\n  col.oc-members  { width: 8%; }   // 97px\n  col.oc-pricing  { width: 7%; }   // \"TIER\" is short — this was 12% and visibly empty\n  col.oc-buyer    { width: 15%; }  // 182px\n  col.oc-profiles { width: 8%; }   // 97px\n  col.oc-indiv    { width: 9%; }   // 109px\n  col.oc-group    { width: 10%; }  // 121px — the widest label\n  col.oc-act      { width: 13%; }  // 158px\n}\n\n// Organization cell: name on line 1, member/team meta (left) + Add Members (right) on line 2\n// The cell is just the name now — members moved to their own column, teams count dropped.\n.org-cell__name { white-space: normal; word-break: break-word; }\n.org-cell__name a { font-weight: 600; }\n\n.org-buyer { max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.invn-col-num { text-align: center; white-space: nowrap; }\n\n// Individual keys — green only. Same size and weight as every other cell: the colour is the\n// signal, and scaling it up made the column shout over the data beside it.\n.invn-keynum {\n  color: #138a72;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  &:hover { color: $clarify-color; }\n}\n\n// ── Pager — mirrors the invitations listing (.invl-pager) ──\n.orgs-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid $color-grey-1;\n  flex-wrap: wrap;\n\n  &__left { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n  &__info { font-size: 12px; color: $color-neutral-mid; }\n\n  // #holder's <li>s are rendered by the component; style them as the invitations page buttons.\n  &__ctrls {\n    display: flex;\n    gap: 4px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 30px;\n      height: 30px;\n      padding: 0 8px;\n      border: 1px solid $color-grey-1;\n      border-radius: 6px;\n      background: #fff;\n      color: $body-content-color;\n      font-size: 12px;\n      font-weight: 600;\n      cursor: pointer;\n      transition: all 0.15s ease;\n\n      &:hover:not(.active) { background: $color-neutral-light; border-color: $color-neutral-mid; }\n      &.active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n    }\n  }\n}\n.orgs-perpage {\n  display: inline-flex; align-items: center; gap: 6px; margin: 0;\n  font-size: 12px; font-weight: 400; color: $color-neutral-mid;\n  select {\n    padding: 4px 8px; border: 1px solid $color-grey-1; border-radius: 6px;\n    font-size: 12px; color: $body-content-color; cursor: pointer; outline: none; background: #fff;\n  }\n}\n\n// Row actions — neutral grey at rest, each revealing its colour on hover.\n// Matches the invitations listing (.invl-actions__opr) and the participants table.\n.invn-acts { display: flex; align-items: center; justify-content: flex-start; gap: 4px; }\n.invn-act {\n  display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; flex-shrink: 0;\n  border-radius: 6px; font-size: 13px; line-height: 1; cursor: pointer; text-decoration: none;\n  background: transparent; color: #9aa0a6; border: 1px solid $color-grey-1;\n  transition: all 0.2s ease;\n\n  // Placeholder holding the graph slot for orgs with no members — keeps the row's icons\n  // aligned with every other row. Inert: no hover, no pointer, not focusable.\n  &.is-empty {\n    opacity: 0.28;\n    cursor: default;\n    pointer-events: none;\n    border-style: dashed;\n  }\n\n  &--addmem:hover { background: $develop-color; color: #fff; border-color: $develop-color; transform: scale(1.08); }\n  &--graph:hover  { background: #1c84c6; color: #fff; border-color: #1c84c6; transform: scale(1.08); }\n  &--edit:hover   { background: $clarify-color; color: #fff; border-color: $clarify-color; transform: scale(1.08); }\n  &--del:hover {\n    background: $implement-color; color: #fff; border-color: $implement-color; transform: scale(1.08);\n    box-shadow: 0 2px 8px rgba($implement-color, 0.3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
